import React, { useContext, useEffect, useState, useRef, useMemo } from 'react';
import { DatabaseContext } from '../../redux/DatabaseStore';
import { useFormik } from 'formik';
import { getRequest, postRequest } from '../../api/ApiController';
import { SaveIcon, AddIcon, CopyIcon, DeleteIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon } from "../svg/svgIcons";
import AuthContext from '../../components/AuthContext';
import UtilContext from '../../components/UtilContext';
import { createAsyncNavigateHandlers } from '../../utils/asyncArrayNavigate';
import { useTrainingCompanies } from '../../utils/useTrainingCompanies';
import { computeCompanyMachineCascade } from '../../utils/trainingSelectionCascade';
import {
    collectTrainingTypeChangedFields,
    emitTrainingTypeListMutation,
} from '../../utils/trainingTypeListSync';
import { confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { Checkbox } from "primereact/checkbox";
import "../../assets/css/docviewer.css";
import "@cyntler/react-doc-viewer/dist/index.css";
import { uiT as t } from '../../utils/uiTranslate';

export function appendTrainingTypeWritePayload(formData, values) {
    const payload = values && typeof values === 'object' ? values : {};
    formData.append('name', payload.name ?? '');
    formData.append('department_id', payload.department_id ?? '');
    formData.append('type', payload.type ?? '');
    formData.append('interval', payload.interval ?? '');
    formData.append('training_company_id', payload.training_company_id ?? '');
    const employeeId = payload.employee_id && typeof payload.employee_id === 'object'
        ? payload.employee_id.id
        : payload.employee_id;
    formData.append('employee_id', employeeId ? employeeId : '');
    formData.append('description', payload.description ?? '');
    formData.append('status', payload.status != null && payload.status !== '' ? payload.status : 'Aktívny');
    const machineIds = (Array.isArray(payload.machines) ? payload.machines : [])
        .map((machine) => (machine && typeof machine === 'object' ? machine.id : machine))
        .filter((id) => id != null && id !== '');
    formData.append('machines', machineIds.join(','));
    if (Object.prototype.hasOwnProperty.call(payload, 'change_before')) {
        formData.append('change_before', payload.change_before ? 'true' : 'false');
    }
}

export default function TrainingTypeAdd({ training_type, type, navigationContext }) {

    const [state, dispatch] = useContext(DatabaseContext);
    const { trainingCompanies, loading: loadingCompanies } = useTrainingCompanies();
    const { user } = useContext(AuthContext);
    const { toast, openFavoriteDialog, setFastView, setDialogText, setVisible } = useContext(UtilContext);
    const [closeTab, setCloseTab] = useState(false);
    const closeAfterRef = useRef(false);
    const submitRef = useRef(null);

    const [formTrainingType, setformTrainingType] = useState(training_type);
    const [formType, setFormType] = useState(type);

    const [images, setImages] = useState('');
    const [visibleFiles, setVisibleFiles] = useState(false);
    const [viewedImage, setViewedImage] = useState('');

    const [templateList, setTemplateList] = useState([]);
    const templateListRef = useRef(null);

    const [insertCopyIcon, setInsertCopyIcon] = useState((user.permissions?.includes("add training")) ? false : true);
    const [scrollIcons, setScrollIcons] = useState((user.permissions?.includes("edit training")) ? false : true);

    const [machines, setMachines] = useState(state.machines ?? []);
    const [companyContactsList, setCompanyContactsList] = useState([]);
    const protocolsLoadedForIdRef = useRef(null);

    useEffect(() => {
        getRequest("/api/company_contacts?minimal=1&module=training")
            .then((r) => {
                const list = r?.data ?? r ?? [];
                setCompanyContactsList(Array.isArray(list) ? list.filter((c) => c?.module === 'training') : []);
            })
            .catch(() => {});
    }, []);

    // Protocols: načítať iba raz pre dané formTrainingType.id (bez dvojitého volania)
    useEffect(() => {
        const id = formTrainingType?.id;
        if (id != null && protocolsLoadedForIdRef.current !== id) {
            protocolsLoadedForIdRef.current = id;
            getImages(id);
        }
    }, [formTrainingType?.id]);

    useEffect(() => {
        if (formTrainingType == null) return;
        const result = computeCompanyMachineCascade({
            companyId: formTrainingType?.training_company_id,
            machineIds: formTrainingType?.machines,
            machines: state.machines ?? [],
            companyContacts: companyContactsList,
        });
        setMachines(result.availableMachines);
    }, [formTrainingType?.id, formTrainingType?.training_company_id, state.machines, companyContactsList]);

    function getImages(id=null){
        getRequest(`/api/training_types/protocols/${id ? id : formTrainingType.id}`).then((response) => {
            console.log(response);
            if(response.data!=="{}")setImages(response.data);
        });
    }

    function addNewTrainingType(){
        dispatch({type:'create_new_tab',name: t('TrainingTypeList.Tab.New'), translationKey: 'TrainingTypeList.Tab.New', legacyLabel: t('TrainingTypeList.Tab.New'),page:'TrainingTypeAdd',props:{training_type: null,type:'add'},mask:'trng006'})
      }
      function copyTrainingType(){
        dispatch({type:'create_new_tab',name: t('TrainingTypeList.Tab.New'), translationKey: 'TrainingTypeList.Tab.New', legacyLabel: t('TrainingTypeList.Tab.New'),page:'TrainingTypeAdd',props:{training_type: formik.values,type:'add'},mask:'trng006'})
      }

    const validate = values => {
        const errors = {};
        if (values?.machines?.length<1) {
            errors.machines = t('Common.RequiredField');
        }
        /*if (!values.type) {
            errors.type = t('Common.RequiredField');
        }*/
        return errors;
    };

    const formik = useFormik({
        initialValues: formTrainingType == null ? {
            name: '', department_id: '', type: '', interval: '', training_company_id: '', machines: [], employee_id: '', description: '', status: 'Aktívny'
        } : {
            id: formTrainingType?.id,
            name: formTrainingType?.name ?? '',
            department_id: formTrainingType?.department_id ?? '',
            type: formTrainingType?.type ?? '',
            interval: formTrainingType?.interval ?? '',
            training_company_id: formTrainingType?.training_company_id ?? '',
            machines: (formTrainingType.machines || []).map(m => ({ name: m?.name, id: m?.id })),
            employee_id: formTrainingType?.employee ? { name: formTrainingType.employee.name, id: formTrainingType.employee.id } : (formTrainingType?.employee_id ? { id: formTrainingType.employee_id, name: '' } : ''),
            description: formTrainingType?.description ?? '',
            status: formTrainingType?.status == null || formTrainingType?.status === '' ? 'Aktívny' : formTrainingType?.status,
            change_before: false,
        },
        enableReinitialize: true,
        validate,
        onSubmit: values => {
            setDialogText(t('Common.Saving'));
            setVisible(true);
            const submitted = { ...values };
            const submittedDescription = submitted.description == null ? '' : String(submitted.description);
            const hadUserEdits = formik.dirty || templateList.length > 0;
            let formData = new FormData();
            appendTrainingTypeWritePayload(formData, submitted);
            for(let i = 0;i<templateList.length;i++){
                formData.append('files[]',templateList[i]);
            }
            const closeAfterSave = closeAfterRef.current;
            if (formType === "add") {
                postRequest('/api/training_types', formData, true)
                    .then((response_first) => {
                        const newId = response_first?.data?.id;
                        if (closeAfterSave) dispatch({ type: 'close_tab', id: state.selectedTab });
                        if (templateList.length && newId) {
                            getImages(newId);
                            setTemplateList([]);
                            templateListRef.current.value = null;
                        }
                        const emitCreate = (row) => {
                            emitTrainingTypeListMutation({
                                operation: 'create',
                                id: newId ?? row?.id ?? null,
                                row: row || null,
                                changedFields: [],
                            });
                        };
                        if (newId) {
                            getRequest(`/api/training_types/${newId}`).then((r) => {
                                const full = r?.data ?? r;
                                setformTrainingType(full);
                                setFormType("edit");
                                formik.setValues({
                                    ...formik.values,
                                    id: full.id,
                                    name: full.name,
                                    department_id: full.department_id,
                                    type: full.type,
                                    interval: full.interval,
                                    training_company_id: full.training_company_id,
                                    machines: (full.machines || []).map(m => ({ name: m?.name, id: m?.id })),
                                    employee_id: full.employee ? { name: full.employee.name, id: full.employee.id } : '',
                                    description: full.description,
                                    status: full?.status == null || full?.status === '' ? 'Aktívny' : full.status,
                                    change_before: false,
                                });
                                emitCreate(full);
                                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                                setVisible(false);
                            }).catch(() => {
                                emitCreate(null);
                                setVisible(false);
                                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                            });
                        } else {
                            setFormType("edit");
                            emitCreate(null);
                            toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordSavedDetail') });
                            setVisible(false);
                        }
                    }).catch((reason) => {
                        setVisible(false);
                        if (!navigator.online) alert(t('Common.OfflineQueued'));
                        else alert(t('Common.Toast.ActionFailedDetail'));
                    });
            } else {
                postRequest(`/api/training_types/update/${formik.values.id}`, formData, true)
                    .then((response_first) => {
                        const saved = response_first?.data;
                        const persistedDescription = saved?.description == null ? '' : String(saved.description);
                        const changePersisted = !hadUserEdits || persistedDescription === submittedDescription;
                        if (closeAfterSave) dispatch({ type: 'close_tab', id: state.selectedTab });
                        formik.setValues(submitted);
                        const attachedFiles = templateList.length > 0;
                        if (attachedFiles && saved?.id) {
                            getImages(saved.id);
                            setTemplateList([]);
                            templateListRef.current.value = null;
                        }
                        if (hadUserEdits && !changePersisted) {
                            setVisible(false);
                            alert(t('Common.Toast.ActionFailedDetail'));
                            return;
                        }
                        const finish = (mutation) => {
                            if (mutation) emitTrainingTypeListMutation(mutation);
                            if (hadUserEdits) {
                                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.RecordUpdatedDetail') });
                            }
                            setVisible(false);
                        };
                        if (!hadUserEdits) {
                            finish(null);
                            return;
                        }
                        const recordId = submitted?.id ?? formik.values.id;
                        const changedFields = collectTrainingTypeChangedFields(formik.initialValues, submitted, {
                            implicitAudit: true,
                            changeBefore: Boolean(submitted?.change_before),
                            hasFiles: attachedFiles,
                        });
                        const emitUpdateFromShow = () => {
                            if (recordId == null) {
                                finish({ operation: 'update', id: null, row: null, changedFields });
                                return;
                            }
                            getRequest(`/api/training_types/${recordId}`).then((r) => {
                                const full = r?.data ?? r;
                                finish({
                                    operation: 'update',
                                    id: recordId,
                                    row: full && typeof full === 'object' ? full : null,
                                    changedFields,
                                });
                            }).catch(() => {
                                finish({ operation: 'update', id: recordId, row: null, changedFields });
                            });
                        };
                        if (submitted?.change_before) {
                            setDialogText(t('Common.LoadingNewData'));
                            Promise.all([
                                getRequest("/api/training_cards"),
                                getRequest("/api/training_employees"),
                            ]).then(emitUpdateFromShow).catch(emitUpdateFromShow);
                        } else {
                            emitUpdateFromShow();
                        }
                    }).catch((reason) => {
                        setVisible(false);
                        if (!navigator.online) alert(t('Common.OfflineQueued'));
                        else alert(t('Common.Toast.ActionFailedDetail'));
                    });
            }
        },
    });

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = useMemo(() => {
        const buildFetchRecord = (toParams = () => '') => async (direction, currentId) => {
            setDialogText?.(t('Common.LoadingShort'));
            setVisible?.(true);
            try {
                const q = toParams();
                const url = `/api/training_types/navigate?direction=${direction}${currentId ? '&id=' + currentId : ''}${q ? '&' + q : ''}`;
                const resp = await getRequest(url);
                return resp?.data ?? null;
            } finally {
                setVisible?.(false);
            }
        };
        if (navigationContext?.filters != null || navigationContext?.sorters != null) {
            const toParams = () => {
                const p = new URLSearchParams();
                (navigationContext.filters || []).forEach(f => {
                    if (f.value != null && String(f.value).trim() !== '') p.set(`filter_${f.field}`, f.value);
                });
                if (navigationContext.sorters?.length) p.set('sorters', JSON.stringify(navigationContext.sorters));
                return p.toString();
            };
            return createAsyncNavigateHandlers(buildFetchRecord(toParams), setformTrainingType, () => formik.values?.id ?? formTrainingType?.id);
        }
        return createAsyncNavigateHandlers(buildFetchRecord(), setformTrainingType, () => formik.values?.id ?? formTrainingType?.id);
    }, [navigationContext, formik.values?.id, formTrainingType?.id]);

    const handleTemplateChange = (event) => {
        setTemplateList(event.target.files);
    };

    const accept = (id) => {
        getRequest(`/api/training_types/deleteProtocol/${id}`)
        .then((response) => {
              toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: t('Common.Toast.FileDeletedDetail') });
              getImages();
          }).catch((reason) => {
              alert(reason);
              toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.Toast.FileDeleteFailedDetail'), life: 3000 });
          })
      };

      const reject = () => {
          toast?.current?.show({ severity: 'warn', summary: t('Common.Rejected'), detail: t('Common.RequestCancelled'), life: 3000 });
      }
  

  function deleteFiles(img){
      confirmDialog({
          message: t('Common.ConfirmDeleteFile'),
          header: t('Common.ConfirmDelete'),
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-danger',
          acceptLabel: 'Nie',
          rejectLabel: t('Common.Yes'),
          accept:reject,
          reject:() => accept(img.id)
      });
  }

    function changeCompany(company_id){
        const result = computeCompanyMachineCascade({
            companyId: company_id,
            machineIds: formik.values?.machines,
            machines: state.machines || [],
            companyContacts: companyContactsList,
        });
        setMachines(result.availableMachines);
        formik.setFieldValue('training_company_id', result.companyId ?? '');
        formik.setFieldValue('machines', result.selectedMachines);
    }

    const machineSelectOptions = useMemo(() => {
        const base = (machines || []).map(m => ({ id: m.id, name: m.name }));
        const sel = formik.values?.machines || [];
        const missing = sel.filter(s => !base.some(b => b.id == (s?.id ?? s)));
        return [...base, ...missing.map(m => ({ id: m?.id ?? m, name: m?.name ?? `Stroj #${m?.id ?? m}` }))];
    }, [machines, formik.values?.machines]);

    const machineSelectValue = useMemo(() => {
        const opts = machineSelectOptions;
        const sel = formik.values?.machines || [];
        const byId = (arr, id) => arr.find(x => (x?.id ?? x) == id);
        return sel.map(m => byId(opts, m?.id ?? m) || { id: m?.id ?? m, name: m?.name ?? `Stroj #${m?.id ?? m}` }).filter(Boolean);
    }, [machineSelectOptions, formik.values?.machines]);

    return ( 
        <>
            <div>
            <div className='w-full h-10 flex flex-row bg-[#333]'>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => { closeAfterRef.current = true; setCloseTab(true); submitRef.current.click(); }}><SaveAndCloseIcon/></button></div>
            <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} type='submit' onClick={() => { closeAfterRef.current = false; setCloseTab(false); submitRef.current.click(); }}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => addNewTrainingType()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" disabled={insertCopyIcon} onClick={() => copyTrainingType()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button className="disabled:opacity-25" onClick={() => openFavoriteDialog(t('TrainingTypeAdd.Text.Nova_typ_skolenia'),"TrainingTypeAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><button onClick={() => setFastView("TrainingTypeAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center '><VerticalLineIcon/></div>
        </div>
        <form onSubmit={formik.handleSubmit}>
        <div className="relative flex flex-col overflow-x min-h-[calc(100vh-177px)]">
          <div className='xl:grid grid-cols-2 gap-1 mb-2 '>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.TYP_SKOLENIA')}</h1>
                {formType=="edit" && <label className="block text-md font-semibold text-gray-800">Por.č.: {formik.values.id}</label>}
                      <div>
                        <label
                            htmlFor="name"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.NAZOV')}</label>
                        <input
                            name='name'
                            type="text" required
                            onChange={formik.handleChange} value={formik.values.name ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="department_id"
                            className="block text-md font-semibold text-gray-800"
                        >
                            ODDELENIE
                        </label>
                        <select 
                        name='department_id'
                        onChange={formik.handleChange} value={formik.values.department_id ?? ''}

                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="">{t('ServiceTaskDetail.SelectDepartment')}</option>
                          {(state.departments || []).map((department) => (
                            <option key={department.id} value={department.id}>{department.name}</option>
                          ))}
                        </select>
                        </div>
                    
                      <div>
                        <label
                            htmlFor="type"
                            className="block text-md font-semibold text-gray-800"
                        >
                            DRUH 
                        </label>
                        <input
                            name='type'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.type ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        <div>
                        <label
                            htmlFor="interval"
                            className="block text-md font-semibold text-gray-800 mt-2"
                        >
                            INTERVAL (v mesiacoch)*
                        </label>
                        <input
                            name='interval'
                            type="number" required
                            onChange={formik.handleChange} value={formik.values.interval ?? ''}
                            className="block w-full  px-4 py-2 mt-2 mb-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        />
                        </div>
                        {formType=="edit" && <div className="flex align-items-center">
                            <Checkbox name="change_before" onChange={e => formik.setFieldValue("change_before",e.checked)} checked={formik.values.change_before} className='p-button-sm p-button-text'/>
                            <label htmlFor="change_before" className="ml-2">{t('Ui.R67.Zmenit_aj_posledne_zaznamy_skoleni')}</label>
                        </div>}        
            </div>
            <div className="w-auto p-6 m-4 bg-gray-100 rounded-md shadow-md">
                       <div>
                        <label
                            htmlFor="training_company_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.SKOL_FIRMA')}</label>
                        <select 
                        name='training_company_id'
                        onChange={(e) => changeCompany(e.target.value)} value={formik.values.training_company_id}
                        required
                        disabled={loadingCompanies}
                        className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'>
                          <option value="">{loadingCompanies ? t('Common.LoadingEllipsis') : t('Common.SelectTrainingCompany')}</option>
                          {(trainingCompanies || []).map((training_company) => (
                            <option key={training_company.id} value={training_company.id}>{training_company.name}</option>
                          ))}
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="machines"
                            className="block text-md font-semibold text-gray-800"
                        >
                            STROJ*
                        </label>
                        <MultiSelect
                            value={machineSelectValue}
                            onChange={(e) => formik.setFieldValue("machines", e.value)}
                            options={machineSelectOptions}
                            optionLabel="name"
                            dataKey="id"
                            filter placeholder={t('Common.SelectMachines')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        {formik.errors?.machines ? <span style={{color: "red"}}>{formik.errors?.machines}</span> : ""}
                        </div> 
                        <div>
                        <label
                            htmlFor="employee_id"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Ui.R67.ZODPOVEDNA_OSOBA')}</label>
                        <Dropdown value={formik.values.employee_id} onChange={(e) => formik.setFieldValue('employee_id',e.value)} 
                             options={(state.employees || []).filter(employee => employee?.date_of_departure == "" || employee?.date_of_departure == null).map((employee) =>
                                ({ name: employee.name, id: employee.id })
                            )} 
                            optionLabel="name" showClear 
                            filter placeholder={t('Common.SelectEmployee')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
                        </div>
                        <div>
                        <label
                            htmlFor="description"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.DescriptionUpper')}</label>
                        <textarea
                            name='description'
                            type="text"
                            onChange={formik.handleChange} value={formik.values.description ?? ''}
                            className="block w-full  px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                        </textarea>
                        </div>
                        <div>
                        <label
                            htmlFor="status"
                            className="block text-md font-semibold text-gray-800"
                        >{t('Common.StatusUpper')}</label>
                        <select
                            name="status"
                            onChange={formik.handleChange}
                            value={formik.values.status != null && formik.values.status !== '' ? formik.values.status : 'Aktívny'}
                            className="block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                        >
                            <option value="Aktívny">{t('Common.Active')}</option>
                            <option value="Zrušený">{t('TrainingTypeList.Status.Cancelled')}</option>
                        </select>
                        </div>
                        <div>
                        <label
                            htmlFor="template"
                            className="block text-md font-semibold text-gray-800"
                        >
                            PREDLOHA
                        </label>
                        <input
                            name='files' 
                            ref={templateListRef}
                            onChange={handleTemplateChange}
                            className='block w-full px-4 py-2 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40'
                            type='file'
                            multiple="multiple"
                            id='template'/>
                        </div>
                        <div>
                        <label
                            htmlFor="images"
                            className="block text-md font-semibold text-gray-800"
                        >
                            Predloha:
                        </label>
                        {images!=='' && images.map((img) => (<table className='w-full border border-separate border-gray-400 rounded-md bg-white mb-4'>
                            <tr>
                                <td className='text-black h-10'><div className='flex flex-row p-2'>
                                    <div onClick={() => setVisibleFiles(true)}>
                                        {img.filename.includes(".docx") ?<img src={require('./../../assets/img/word.png')} style={{ height: '65px', width: 'auto'}} alt="Word Logo"/> :<embed src={img.url+'#view=FitH&scrollbar=0'} width='100px' height='65px'></embed>}
                                    </div>
                                        <div className='flex flex-col ml-4'>
                                        <a style={{color:'blue',cursor:'pointer',marginBottom:'2px'}} onClick={() => {setVisibleFiles(true);setViewedImage(img)}}>{img.filename}</a>
                                        <button type="button" className='w-fit flex flex-row px-2 py-1 border rounded-md bg-red-900' onClick={() => {setViewedImage(img);deleteFiles(img)}} ><DeleteIcon/><span className='text-white ml-1'>{t('Common.Clear')}</span></button>
                                        </div>
                                    </div></td>
                            </tr>
                        </table>))}
                        </div>
                        <button className='hidden' type='submit' ref={submitRef}></button>    
            </div>
            </div>
            </div> 
             </form>
             <Dialog header={t('Common.PdfPreview')} visible={visibleFiles} onHide={() => setVisibleFiles(false)} style={{ width: '80vw',height:'90vh',backgroundColor: 'transparent',boxShadow: 'none'}}>
             {viewedImage?.filename?.includes(".docx") ? <DocViewer prefetchMethod="GET" pluginRenderers={DocViewerRenderers} documents={[{uri:viewedImage.url}]} style={{width:'100%',height:'70vh'}} /> : <iframe src={viewedImage.url} className='w-full h-full'></iframe>}
            </Dialog>
            </div>
            </> 
            );
} 
